/**
 * Created by luka on 23.02.2018.
 */

import {
    DECLINE_PAYOUT_LOADING, DECLINE_PAYOUT_SUCCESS, LOADING_DECLINE_PAYOUT_FAILED
} from "../actions/types";
export function loadingDeclinePayoutFailed(state = false, action) {
    switch (action.type) {
        case LOADING_DECLINE_PAYOUT_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function declinePayoutLoading(state = false, action) {
    switch (action.type) {
        case DECLINE_PAYOUT_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function declinePayoutSuccess(state = {}, action) {
    switch (action.type) {
        case DECLINE_PAYOUT_SUCCESS:
            return action.workoutBlock;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/payout/DeclinePayoutReducer.js